import { FtlRouteViewModel } from "../../../../../ViewModel/FtlRouteViewModel";

export const getGsdbAddErrorMessage = (element: any, route: FtlRouteViewModel) => {
  if (route.RouteType === "FTL" && element.Type !== "ODC") {
    return undefined;
  }
  if (route.RouteType === "Trunk" && element.Type !== "Supplier") {
    return undefined;
  }
  if (route.RouteType === "FTL2" && (element.Type !== "Plant" || element.Type !== "EDC")) {
    return undefined;
  }
  if (route.RouteType === "Top-Up") {
    return undefined;
  }
  if (route.RouteType === "ST-Return") {
    return undefined;
  }

  return `You can't add a ${element.Type} to a ${route.RouteType} route`;
};
